export default "__VITE_ASSET__CKMPV08t__"